import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export const TRANSACTION_TYPES = {
	replenish: 'replenish',
	withdraw: 'withdraw',
} as const satisfies Record<string, string>;

export type TransactionType = (typeof TRANSACTION_TYPES)[keyof typeof TRANSACTION_TYPES];

export const transactionTypeSchema: ZodType<TransactionType> = z.nativeEnum(TRANSACTION_TYPES);

export const TRANSACTION_AGENT_TYPES = {
	account: 'account',
	cashdesk: 'cashdesk',
} as const satisfies Record<string, string>;

export type Transaction = {
	id: string;
	amount: number;
	from: EntityWithName | null;
	to: EntityWithName | null;
	currency: string;
	type: TransactionType;
	balanceAfter: number | null;
	createdAt: string;
};

export const transactionSchema: ZodType<Transaction> = z.object({
	id: z.string(),
	amount: z.number(),
	from: entityWithNameSchema.nullable(),
	to: entityWithNameSchema.nullable(),
	currency: z.string(),
	type: transactionTypeSchema,
	balanceAfter: z.number().nullable(),
	createdAt: z.string(),
});
